import {addToSortedArray} from "@prosay/common"
import {getLogger} from "@prosay/logging"
import {useEffect} from "react"
import {
    MessageInfoFragment,
    MessagesDocument,
    MessagesSubscription,
    MessagesSubscriptionVariables,
    useGetMessagesQuery,
} from "../graphql"
import {compareMessagesByDate} from "../util"
import {updateLiveQuery} from "./liveQuery"

const logger = getLogger(__filename)

const addMessage = (
    value: MessageInfoFragment,
    list: readonly MessageInfoFragment[],
) => addToSortedArray(list, value, compareMessagesByDate)

export const useMessages = (conversationId: string) => {
    const query = useGetMessagesQuery({variables: {conversationId}})
    const {subscribeToMore} = query
    useEffect(
        () =>
            subscribeToMore<
                MessagesSubscription,
                MessagesSubscriptionVariables
            >({
                document: MessagesDocument,
                updateQuery: updateLiveQuery(
                    "getMessages",
                    ({messages}) => {
                        logger.debug`Got the following response from useMessages subscription: ${messages}`
                        return messages && [messages.message, messages.type]
                    },
                    {add: addMessage},
                ),
                variables: {conversationId},
            }),
        [conversationId, subscribeToMore],
    )
    return query
}
